import styled from 'styled-components';
import ModalDialog from './ModalDialog';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: ${({ show }) => show ? '15px' : '0px'};
  padding-left: ${({ show }) => show ? '15px' : '0px'};
  background-color: rgba(0, 0, 0, .50);
  opacity: ${({ show }) => show ? 1 : 0};
  transition: opacity 0.2s ease-in;
  height: ${({ show }) => show ? 'auto' : 0};
  &.fullScreen{
    padding:0px;
    margin:0px;
    ${ModalDialog}{
      max-width: 100%;
      width:100%;
      padding:0px;
      margin:0px;
      ${ModalHeader}{
        padding:0px;
        h5{
        display:none;
      }
      button{
        position:absolute;
        right:0px;
        top:0px;
        z-index:9;
      }
      }
      ${ModalBody}{
        padding:0px;
      }
      img{
        width:100%;
      }
    }
  }
`;

export default ModalWrapper;



// WEBPACK FOOTER //
// client/components/Modal/ModalWrapper.js